module.exports = __webpack_public_path__ + "static/media/deversifi.67b302a3.svg";